import './local.css';

function Simplify(){
    return (
        <div className='App'>
            <div className="container">
                <div className='header'>
                    <h1>Simplify</h1>
                </div>
                <div className="body">
                    <p>Simplify é uma plataforma criada com o objetivo de simplificar, inovar e tornar transparente a gestão de contratos e acordos a nível de serviços em ambientes corporativos. Desenvolvida para empresas que necessitam gerenciar múltiplos contratos e acordos de forma profissional e eficiente.</p>
                    
                    <p>A Simplify possuí as seguintes funcionalidades:</p>

                    <ul>
                        <li><strong>Gestão de Contratos:</strong> Centralize todos os seus contratos corporativos numa única plataforma, com fácil acesso e organização por categorias, fornecedores, datas ou departamentos.</li>
                        <li><strong>Controle de Vencimentos:</strong> Sistema de alertas automáticos que notifica sobre renovações, vencimentos e datas importantes, evitando perda de prazos críticos.</li>
                        <li><strong>Arquivo Digital Seguro:</strong> Armazenamento seguro de todos os documentos contratuais com controle de versões, assinaturas digitais e histórico de alterações.</li>
                        <li><strong>Painel de Indicadores:</strong> Dashboard com visão geral de todos os contratos ativos, valores envolvidos, status de cumprimento e indicadores de desempenho de fornecedores.</li>
                        <li><strong>Gestão de Condições:</strong> Acompanhamento de cláusulas, condições de pagamento, níveis de serviço (SLA) e outras obrigações contratuais.</li>
                        <li><strong>Relatórios Customizados:</strong> Geração de relatórios personalizados sobre despesas contratuais, desempenho de fornecedores, cumprimento de prazos e muito mais.</li>
                        <li><strong>Controle de Acessos:</strong> Diferentes níveis de permissão para usuários, garantindo que apenas pessoas autorizadas tenham acesso às informações sensíveis.</li>
                        <li><strong>Workflow de Aprovação:</strong> Processos automatizados de aprovação de novos contratos, renovações ou alterações, com trilha de auditoria completa.</li>
                    </ul>

                    <p><strong>Benefícios para sua Empresa:</strong></p>
                    <ul>
                        <li>Redução de riscos com controle efetivo de vencimentos e obrigações</li>
                        <li>Maior transparência nas relações contratuais</li>
                        <li>Otimização de custos com melhor negociação e planejamento</li>
                        <li>Conformidade legal e regulatória facilitada</li>
                        <li>Aumento de produtividade das equipas administrativas</li>
                        <li>Decisões mais informadas com dados consolidados</li>
                        <li>Eliminação de documentos físicos e processos manuais</li>
                    </ul>

                    <p>A INOVATIS MZ, entendendo os desafios dos ambientes corporativos modernos, disponibiliza o Simplify como uma solução completa para gestão de contratos, focada na simplicidade de uso, segurança da informação e eficiência operacional.</p>
                </div>
            </div>
        </div>
    )
}

export default Simplify
